import { string, z } from 'zod';
import { mongoId, mongoIdSchema } from '../utils/basicSchemas/_id.z.schema';
import { ZSchema } from '../utils/zodSchema';

const commentTextSchema = z.string().min(1, "Comment Text is Required").max(500, "Comment must be maximum 500 chars.");
const commentPriceSchema = z.number().min(0, "Comment Price must be a positive number");

// Schema for validating comment creation and updates.
const commentValidationSchema = z.object({
    postId: mongoId("Item id"),
    commentText: commentTextSchema,
    commentPrice: commentPriceSchema.optional(),
    taggedUser: z.array(string()).optional()
}).strict();

// chema for comment replies
const commentReplyValidationSchema = z.object({
    postId: mongoId("Item id"),
    commentText: commentTextSchema,
    commentPrice: commentPriceSchema.optional(),
    taggedUser: z.array(string()).optional(),
    parentComment: mongoId("Parent comment id")
}).strict();

// Schema for validating comment ID.
const commentIdSchema = z.object({
    id: mongoId("Comment id"),
});


// Schema for validating comment updates.
const updateCommentValidationSchema = z.object({
    commentText: commentTextSchema.optional(),
    commentPrice: commentPriceSchema.optional()
});


const commentIdValidator = new ZSchema({ paramSchema: commentIdSchema });
const commentValidator = new ZSchema({ bodySchema: commentValidationSchema });
const commentUpdateValidator = new ZSchema({ bodySchema: updateCommentValidationSchema });
const commentReplyValidator = new ZSchema({ bodySchema: commentReplyValidationSchema });


export {
    commentValidationSchema,
    updateCommentValidationSchema,
    commentReplyValidationSchema
};

export { commentIdValidator, commentValidator, commentUpdateValidator, commentReplyValidator };